import { AuthenticatedRoute } from "@components/AuthenticatedRoute";
import { NavItems } from "@helpers/navigation";
import { RoleId } from "@store/generalTypes";
import { Route, Routes, useLocation } from "react-router-dom";
import { AdminShell } from "../../../components/AdminShell";
import { ResultsNav } from "../components/resultsNav";
import { ResultsDetails } from "./resultsDetails";
import { ResultsOverview } from "./resultsOverview";

export const ResultsLanding = (): JSX.Element => {
    const { pathname } = useLocation();

    const routes = (
        <AuthenticatedRoute roles={[RoleId.Clinician, RoleId.DataQA, RoleId.Researcher]}>
            <Routes>
                <Route path={NavItems.Admin.Results.Details.relativePath + ":id"} element={<ResultsDetails />} />
                <Route
                    path={NavItems.Admin.Results.parentRoot.relativePath}
                    element={<ResultsOverview isArchive={false} />}
                    key={NavItems.Admin.Results.parentRoot.relativePath}
                />
                <Route
                    path={NavItems.Admin.Results.Archived.relativePath}
                    element={<ResultsOverview isArchive={true} />}
                    key={NavItems.Admin.Results.Archived.relativePath}
                />
            </Routes>
        </AuthenticatedRoute>
    );

    return (
        <AdminShell
            routes={routes}
            showLanguage={pathname.includes(NavItems.Admin.Results.Details.relativePath)}
            nav={<ResultsNav />}
        />
    );
};
